import { type ReactNode, Children, isValidElement } from 'react';

export const CONTROL_WIDTH = 37.5;

/**
 * Estimates toolbar size depending on defined children count
 *
 * @param children -
 */
export const estimateToolbarWidth = (children: ReactNode) => {
  let definedChildren = 0;
  Children.forEach(children, (child) => {
    if (isValidElement(child)) {
      definedChildren++;
    }
  });
  return definedChildren * CONTROL_WIDTH;
};
